export default "__VITE_ASSET__123d4adc__"